export default {
      id: "arrow-down-left-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#arrow-down-left",
      toString: function () {
        return this.url;
      }
    }